import React, { useEffect, useState } from "react";
import { fetchApiData } from "../../../store/slicers/apiSlicer.js";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import "../../styles/siderbar.css";
import useChangeLanguage from "../../../logic/useChangeLanguage.js";

const Sidebar = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [adminHeaders, setAdminHeaders] = useState([]);
  const [expandedSections, setExpandedSections] = useState({});

  const { _t, getArticleTitle } = useChangeLanguage();

  const { data, isLoading } = useSelector((state) => ({
    data: state.apiData?.data?.adminHeaders,
    isLoading: state.apiData?.loading?.adminHeaders,
  }));

  useEffect(() => {
    getAdminHeaders();
  }, []);

  useEffect(() => {
    if (data) {
      setAdminHeaders(data);
    }
  }, [data]);

  const getAdminHeaders = () => {
    dispatch(
      fetchApiData({
        url: "adminheades",
        itemKey: "adminHeaders",
      })
    );
  };

  const toggleSection = (id) => {
    setExpandedSections((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const untoggleSection = (id) => {
    setExpandedSections((prev) => ({
      ...prev,
      [id]: false,
    }));
  };

  const handleContentClick = (headerId, contentId) => {
    history.push(`/admin-content/${headerId}/${contentId}`);
  };

  if (isLoading) {
    return (
      <aside className="sidebar">
        <h3>Chargement...</h3>
        <div className="text-center py-3">
          <i
            className="pi pi-spin pi-spinner"
            style={{ fontSize: "2rem", color: "#00a652" }}
          ></i>
        </div>
      </aside>
    );
  }

  return (
    <aside className="sidebar">
      <h3>{_t("administration")}</h3>

      <ul className="admin-sidebar-list">
        {adminHeaders.map((header) => (
          <li key={header.id} className="admin-header-item">
            <div
              className="admin-header-title"
              onMouseOver={() => toggleSection(header.id)}
            >
              <i
                className={`pi ${
                  expandedSections[header.id]
                    ? "pi-minus"
                    : "pi-angle-double-right"
                } me-2`}
              ></i>
              {getArticleTitle(header)}
            </div>

            {expandedSections[header.id] && header.admin_contents && (
              <ul className="admin-contents-list">
                {header.admin_contents.map((content) => (
                  <li key={content.id} className="admin-content-item">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleContentClick(header.id, content.id);
                      }}
                    >
                      <div className="icon">
                        <i className="pi pi-angle-right"></i>
                      </div>
                      <div className="content">{getArticleTitle(content)}</div>
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default Sidebar;
